export const SET_CLIENT_ERROR = 'SET_CLIENT_ERROR'
export const SET_RTC_CONNECTION_TIME = 'SET_RTC_CONNECTION_TIME'
export const SET_RTC_DISCONNECTION_TIME = 'SET_RTC_DISCONNECTION_TIME'
export const SET_ON_GO_BACK_TO_PUBLIC = 'SET_ON_GO_BACK_TO_PUBLIC'
